/**
 * The job that moved a dictation to `FAILED` (Spec § 3.1 `failed_step`). A
 * failed draft generation is recorded on the draft row, not here — the
 * dictation stays `TRANSCRIBED` and the phase table derives `failed`.
 */
export var DictationFailedStep;
(function (DictationFailedStep) {
    DictationFailedStep["NORMALIZE_AUDIO"] = "normalize-audio";
    DictationFailedStep["TRANSCRIBE"] = "transcribe";
})(DictationFailedStep || (DictationFailedStep = {}));
//# sourceMappingURL=dictation-failed-step.enum.js.map